import { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';
import { Button, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationButton = (props: ComponentProps<typeof Button>) => {
  return <Button style={styles.button} size="large-wide" {...props} />;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  button: {
    borderWidth: 0,
    minHeight: 72,
    minWidth: 190,
    paddingHorizontal: theme.spacing['8'],
  },
});
